import { fnr } from "@navikt/fnrvalidator";

export function isDevEnv() {
	const base = import.meta.env.VITE_MITT_NTE_APP_BASE_URL || "";
	return base.includes(".nte.dev") || base.includes("localhost");
}

export function getUcBaseLink() {
	return `https://widget${isDevEnv() ? ".stag" : ""}.utilitycloud.app`;
}

export function getUcMeteringvaluesBaseLink() {
	return `https://uc-meteringvalues.marked.azure.nte.${isDevEnv() ? "dev" : "no"}`;
}

export function getUcEventconsumerBaseLink() {
	return `https://uc-eventconsumer.marked.azure.nte.${isDevEnv() ? "dev" : "no"}`;
}

export function getStrombestillingBaseLink() {
	return `https://strombestilling-api.nte.${isDevEnv() ? "dev" : "no"}`;
}

export function getStromtilbudUrlRoot() {
	return `https://stromtilbud.nte.${isDevEnv() ? "dev" : "no"}`;
}

export const capitalizeFirstLetter = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalizeFirstLetterRestLower = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export function validateFodselsnummer(fodselsnummer?: string) {
	if (!fodselsnummer) return false;
	else {
		return fnr(fodselsnummer).status === "valid";
	}
}

export const dateFormat = "yyyy-MM-dd'T'HH:mm";
